import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ViewPageWrapper from 'components/ViewPageWrapper';
import ViewBetslipItem from 'components/ViewBetslipItem';
import AcceptBetslipChanges from 'components/AcceptBetslipChanges';
import { ViewOddsInput } from 'components/ViewInput';
import ViewOverlayLoader from 'components/ViewOverlayLoader';
import { browserHistory } from 'react-router';
import * as BetslipActions from 'actions/BetslipActions';
import * as UiActions from 'actions/UiActions';
import 'css/BetslipPage.css';
import cookie from 'react-cookies';
import {
    getLiveEventByBet,
    getStakeAmountMTSStakeError,
    isLiveBetActive,
    isMTSStakeError,
} from 'utils/Helper';
import MobileFormWrapper from 'components/MobileFormWrapper';
import { NotificationManager } from 'react-notifications';
import UIModal from 'components/UIModal';
import {
    disableBodyScroll,
    enableBodyScroll,
    isTerminal,
} from 'utils/UiHelper';
import Button from 'ui/Button';
import { browserHistoryGoBack } from '../utils/UiHelper';
import { SYSTEM_NAMES_WEB } from '../constants/appConfig';
import Wrapper from '../ui/Wrapper';
import Text from '../ui/Text';
import InfoIconRed from 'images/icons/info_circle_red.svg';
import {
    getButtonAmount,
    getButtonFreeBetLabel,
    getPossibleWinAmount,
    isPlaceBetDisabled,
    showSingleCustomBetErrorMessage,
} from '../features/Betslip/helperFreebet';
import NewsletterPermissionSwitch from '../features/RightSidebar/NewsletterPermissionSwitch';
import ViewSpinner from '../components/ViewSpinner';
import Arrow from 'images/arrowWhite.svg';

class BetslipPage extends Component {
    validationHandlers = {};
    constructor() {
        super();

        this.state = {
            activeDropdown: true,
            oddsValues: {},
            customBetStake: 0,
            freeBetEnabled: false,
            hasPlacedBet: false,
            rulesContent: null,
            isEmailValidForNewsletter: true,
            isAcceptedBetslipChanges:
                cookie.load('isAcceptedBetslipChanges') === 'true',
            setFixedButton: false,
        };
        this.systemRef = React.createRef();
        this.onClickPlacerBtnHandler = this.onClickPlacerBtnHandler.bind(this);
    }

    rightRedirect() {
        if (window.locationHistory.length > 0) {
            browserHistory.push(`/sport${window.locationHistory[0]}`);
        } else {
            browserHistory.push('/sport/');
        }
    }

    _isBetslipEmpty(newProps) {
        if (newProps && !newProps.success) {
            if (newProps.betslip.betList.length === 0) {
                this.rightRedirect();
            }
        } else {
            if (this.props.betslip.betList.length === 0) {
                this.rightRedirect();
            }
        }
    }

    onRightBtnHandler() {
        this.props.betslip.customBetEventId !== null ||
        this.props.betslip.placedCustomBetMarkets.length > 0
            ? this.props.betslipActions.clearAllCustomBetMarkets()
            : this.props.betslipActions.clearAllMarkets();
    }

    onCloseHandler() {
        browserHistoryGoBack();
    }

    showStakeSuggestionNotification() {
        NotificationManager.error(
            '',
            `Indsatsen er for høj. Det maksimale beløb for dette spil er ${getStakeAmountMTSStakeError(
                this.props.betslip.error
            )} kr.`,
            10 * 1000
        );
    }

    onCloseModal() {
        this.setState({ rulesContent: null });
    }

    componentDidMount() {
        if (this.props.betslip?.system?.stake?.length) {
            let oddsValues = {};
            this.props.betslip?.system?.stake.forEach((stake, index) => {
                if (stake !== 0) {
                    oddsValues[
                        `odds-${this.props.betslip.system.names[index]}`
                    ] = stake;
                }
            });
            this.setState({ oddsValues });
        } else if (this.props.betslip?.singleStake) {
            this.setState({
                oddsValues: { 'odds-0': this.props.betslip.singleStake },
            });
        } else if (this.props.betslip?.customBetEventId !== null) {
            this.setState({
                oddsValues: { 'odds-0': this.props.betslip.customBetStake },
            });
        }
        this.checkContentHeight();
        disableBodyScroll();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.betslip.error && this.props.betslip.error) {
            if (isMTSStakeError(this.props.betslip.error)) {
                this.showStakeSuggestionNotification();
            }
        }
        if (
            prevProps.betslip.hasMarkets.length !==
            this.props.betslip.hasMarkets.length
        ) {
            this.checkContentHeight();
            if (this.props.betslip.hasMarkets.length === 0) {
                this.setState({
                    ...this.state,
                    activeDropdown: true,
                });
            }
            if (this.props.betslip.customBetEventId === null) {
                this.setState({
                    customBetStake: 0,
                });
            }
        }
    }

    componentWillUnmount() {
        enableBodyScroll();
    }

    checkContentHeight() {
        const box = document.getElementById('systemBox');
        const windowHeight = window.innerHeight;
        setTimeout(() => {
            const boxHeight = box.offsetHeight;
            if (boxHeight + 50 > windowHeight) {
                this.setState({
                    ...this.state,
                    setFixedButton: true,
                });
            } else {
                this.setState({
                    ...this.state,
                    setFixedButton: false,
                });
            }
        }, 50);
    }

    onClickPlacerBtnHandler() {
        if (this.props.auth.user) {
            if (this.props.betslip.customBetEventId !== null) {
                this.props.betslipActions.proceedCustomBet(
                    this.props.betslip.totalOdds,
                    this.props.betslip.customBetStake,
                    this.props.betslip,
                    this.state.freeBetEnabled ? 1 : 0,
                    this.props.auth.user.freeBet,
                    this.props.auth?.user?.freeBetSettleType === 1
                );
            } else {
                this.props.betslipActions.proceed(
                    this.props.betslip,
                    this.state.isAcceptedBetslipChanges,
                    false,
                    this.state.freeBetEnabled ? 1 : 0,
                    this.props.auth.user.freeBet
                );
            }
            this.setState({ hasPlacedBet: true });
        } else {
            this.props.uiActions.showModal('LOGIN_MOBILE');
        }
    }

    onClickPlaceBetHandler = () => {
        const customBetStake = this.props.betslip.customBetStake;
        const betAmount = this.props.betslip.singleStake;
        const userBalance = this.props.auth.user.balance;
        const totalStakeAmount = this.props.betslip.system.totalStake;

        if ((betAmount || totalStakeAmount || customBetStake) > userBalance) {
            this.props.uiActions.showModal('LOW_BALANCE');
        }
    };

    onClickFreeBetUse() {
        this.setState({ freeBetEnabled: !this.state.freeBetEnabled });
    }

    valueHandler(name, val) {
        if (this.props.betslip.customBetEventId !== null) {
            let oddsValues = this.state.oddsValues;

            oddsValues[name] = val;

            this.setState({ oddsValues, customBetStake: val });

            this.props.betslipActions.setCustomBetMarket(
                val,
                this.props.betslip.totalOdds
            );
        } else {
            let oddsValues = this.state.oddsValues;

            oddsValues[name] = val;

            this.setState({ oddsValues });

            this.props.betslipActions.setMarket(
                val,
                this.props.betslip.totalOdds
            );
        }
    }

    valueSystemHandler(index, name, val) {
        let oddsValues = this.state.oddsValues;

        oddsValues[name] = val;

        this.setState({ oddsValues });

        this.props.betslipActions.setSystemMarket(val, index);
    }

    onRemoveHandler(item) {
        this.props.betslipActions.clearSingleMarket(item.eventId, item.gameId);
    }

    onRemoveSystemHandler(item) {
        this.props.betslip.customBetEventId !== null
            ? this.props.betslipActions.clearSingleCustomBetMarket(
                  item.marketId,
                  item.betNr
              )
            : this.props.betslipActions.clearSystemMarket(
                  item.eventId,
                  item.gameId
              );
    }

    componentWillMount() {
        this._isBetslipEmpty();
    }

    componentWillReceiveProps(newProps) {
        this._isBetslipEmpty(newProps);

        if (newProps.betslip.betList !== this.props.betslip.betList) {
            this.setState({ oddsValues: {} });
        }
    }

    onClickAceptBtnHandler() {
        this.props.betslipActions.acceptMarkets();
    }

    /*isPlaceBetDisabled(betslip) {
        if (this.state.freeBetEnabled && this.props?.auth?.user?.freeBet > 0) {
            return false;
        } else if (betslip?.system?.stake?.length) {
            return (
                betslip.system.stake.every((bet) => bet === 0 || bet < 5) ||
                betslip.system.stake.some((bet) => bet > 0 && bet < 5)
            );
        } else {
            //console.log('cond', typeof Betslip?.customBetStake === 'undefined')
            return betslip?.customBetEventId > 0
                ? betslip?.customBetStake < 10 ||
                      typeof betslip?.customBetStake === 'undefined'
                : betslip?.singleStake < 10;
        }
    }*/

    onAcceptBetslipChanged = (status) => {
        this.setState({
            isAcceptedBetslipChanges: status,
        });

        let d = new Date();

        d.setTime(d.getTime() + 180 * 24 * 60 * 60 * 1000);

        cookie.save('isAcceptedBetslipChanges', status, {
            path: '/',
            expires: d,
        });
    };

    isLiveBetActive(bet) {
        //TODO check for live customBet
        const event = getLiveEventByBet(bet, this.props.liveEvents.data);
        const market = this.props.betslip.liveMarkets[bet.gameId];
        return isLiveBetActive(bet, event, market);
    }

    inputCheckHandler(name, handler) {
        this.validationHandlers[name] = handler;
    }

    setEmailValidity = (isValid) => {
        this.setState({ isEmailValidForNewsletter: isValid });
    };

    shouldFreeBetShow(betslip) {
        const isLoggedIn = () => this.props.auth && this.props.auth.user;
        const isBiggerOdds = () =>
            this.props.betslip.totalOdds > this.props.auth.user.freeBetMinOdds;
        const user = this.props.auth.user;
        const shouldShowButton = () => {
            let shouldShow;
            if (user.freeBetAmount > 0 && user.freeBetType === 0) {
                shouldShow = true;
            } else if (
                user.freeBetLive &&
                (user.freeBetType === 0 || user.freeBetType === 3)
            ) {
                shouldShow =
                    user.freeBet &&
                    user.freeBet !== 0 &&
                    user.freeBetLive &&
                    betslip.betList.some(
                        (event) =>
                            (event.competitionId === user.freeBetEventId ||
                                event.eventId === user.freeBetEventId) &&
                            event.live
                    );
            } else if (
                user.freeBetLive &&
                (user.freeBetType === 1 || user.freeBetType === 3)
            ) {
                shouldShow =
                    user.freeBet &&
                    user.freeBet !== 0 &&
                    user.freeBetLive &&
                    betslip.betList.some(
                        (event) =>
                            event.eventId === user.freeBetEventId && event.live
                    );
            } else if (
                user.freeBetLive &&
                (user.freeBetType === 2 || user.freeBetType === 3)
            ) {
                shouldShow =
                    user.freeBet &&
                    user.freeBet !== 0 &&
                    user.freeBetLive &&
                    betslip.betList.some(
                        (event) =>
                            event.competitionId === user.freeBetEventId &&
                            event.live
                    );
            } else if (!user.freeBetLive) {
                shouldShow = user.freeBet && user.freeBet !== 0;
            }
            return shouldShow;
        };
        return isLoggedIn() && isBiggerOdds() && shouldShowButton();
    }

    FreeBetRow(betslip) {
        let text =
            this.props.auth?.user?.freeBetSettleType === 1
                ? 'Freebet'
                : this.props.auth?.user?.freeBetLive === 1
                    ? 'Live Bet'
                    : 'Ekstra Bet';
        if (this.shouldFreeBetShow(betslip)) {
            return (
                <div className="WrapperFreeBetButton">
                    <Button
                        margin="0"
                        padding="0"
                        className={`view-button extrabet-btn ${
                            this.state.freeBetEnabled ? 'green-btn' : ''
                        }`}
                        onClick={() => {
                            this.onClickFreeBetUse();
                        }}
                    >
                        {' '}
                        {`Benyt mit ${text} på ${this.props.auth.user &&
                            this.props.auth.user.freeBet} kr.`}
                    </Button>
                </div>
            );
        } else {
            return null;
        }
    }

    isActivePlaceDisabled(betslip) {
        if (this.state.freeBetEnabled) {
            return false;
        } else if (betslip?.system?.stake?.length) {
            return (
                betslip.system.stake.every((bet) => bet < 5) ||
                betslip.system.stake.some((bet) => bet !== 0 && bet < 5)
            );
        } else {
            return betslip?.customBetEventId > 0
                ? betslip?.customBetStake < 10 ||
                      typeof betslip?.customBetStake === 'undefined'
                : betslip?.singleStake < 10;
        }
    }

    render() {
        const betslip = this.props.betslip;
        const isCustomBet = betslip.isCustomBet;
        const user = this.props.auth.user;
        const { hasPlacedBet } = this.state;
        const isDerbyPermissionNull =
            this.props.auth?.user?.derbyPermission === null;
        const userEmail = this.props.auth?.user?.email;
        const shouldDisplayNewsletter = this.props.auth?.user?.newsletter === 0;
        const betSlipButtons = (
            <div className="relative-container">
                {betslip.pending && <ViewSpinner className="view-spinner" />}
                {!betslip.changed ? (
                    <Fragment>
                        <Button
                            margin="0 auto"
                            width="100%"
                            active={
                                !isPlaceBetDisabled(
                                    betslip,
                                    user,
                                    this.state.freeBetEnabled
                                )
                            }
                            disabled={
                                !this.state.isEmailValidForNewsletter ||
                                isPlaceBetDisabled(
                                    betslip,
                                    user,
                                    this.state.freeBetEnabled
                                ) ||
                                betslip.pending
                            }
                            onClick={() => {
                                this.onClickPlacerBtnHandler();
                                this.onClickPlaceBetHandler();
                            }}
                            yellow
                        >
                            {`Placer væddemål  ${getButtonAmount(
                                betslip,
                                this.props.auth,
                                this.state.freeBetEnabled
                            )} ${getButtonFreeBetLabel(
                                this.props.auth,
                                this.state.freeBetEnabled
                            )}`}
                        </Button>
                    </Fragment>
                ) : (
                    <Button
                        active
                        margin="0 auto"
                        width="100%"
                        disabled={betslip.pending}
                        onClick={this.onClickAceptBtnHandler.bind(this)}
                    >
                        Accepter oddsændring
                    </Button>
                )}
            </div>
        );

        let amountButtonText =
            betslip.customBetPrize > 0 ||
            betslip.system.totalPrize > 0 ||
            betslip.singlePrize > 0
                ? `${
                      isCustomBet
                          ? betslip.customBetPrize.toFixed(2)
                          : betslip.singlePrize > 0
                              ? betslip.singlePrize.toFixed(2)
                              : betslip.system.totalPrize.toFixed(2)
                  } kr`
                : '';

        let disableSystemButton =
            (betslip.system.stake.every((bet) => bet === 0 || bet < 5) ||
                betslip.system.stake.some((bet) => bet > 0 && bet < 5)) &&
            !this.state.freeBetEnabled;

        let errorMessageSingle = 'Min. indsatsen er 10 kr.';
        let errorMessageSystem = 'Min. indsatsen er 5 kr.';

        const betListView =
            betslip.betList.length > 1 &&
            betslip.customBetEventId === null &&
            betslip.placedCustomBetMarkets.length === 0 ? (
                <section className={'section-wrapper'}>
                    <div className="multiple-coupon">
                        <Wrapper
                            boxSizing={'border-box'}
                            height={'auto'}
                            flex
                            justify="space-between"
                            padding="0"
                        >
                            <Text
                                condensed
                                size="14"
                                color="#333333"
                                lh={'14'}
                                padding={'0'}
                                margin={'0'}
                            >
                                {`${
                                    SYSTEM_NAMES_WEB[betslip.betList.length - 1]
                                }:`}
                                <span className={'arrow-right'} />
                            </Text>

                            <Text
                                align="right"
                                condensed
                                size="14"
                                lh={'14'}
                                color="#333333"
                                padding={'0'}
                                margin={'0'}
                            >
                                {betslip.totalOdds.toFixed(2)}
                            </Text>
                        </Wrapper>
                        <Wrapper
                            boxSizing={'border-box'}
                            height={'auto'}
                            flex
                            padding={'10px 0 0'}
                            justify={'space-between'}
                        >
                            <div
                                className={`dropdown ${
                                    this.state.activeDropdown ? 'active' : ''
                                } `}
                                onClick={() => {
                                    this.setState({
                                        ...this.state,
                                        activeDropdown: !this.state
                                            .activeDropdown,
                                    });
                                }}
                            >
                                {`Vis ${
                                    this.state.activeDropdown
                                        ? 'flere'
                                        : 'færre'
                                } spil`}
                                <img src={Arrow} className={'arrow'} alt="" />
                            </div>
                        </Wrapper>
                        <Wrapper
                            boxSizing={'border-box'}
                            padding={'0'}
                            margin={'-35px 0 0'}
                            height={`${
                                this.state.activeDropdown ? '40px' : 'auto'
                            }`}
                            transition={'all 0.4s ease-in-out'}
                            overflow={'hidden'}
                        >
                            <MobileFormWrapper inputBlurOnSubmit={true}>
                                {betslip.system.names
                                    .filter((name) => name)
                                    .map((name, index) => (
                                        <Wrapper
                                            boxSizing={'border-box'}
                                            height={'auto'}
                                            flex
                                            padding={'15px 0 0 '}
                                            key={`system${index}`}
                                        >
                                            <Text
                                                align="left"
                                                condensed
                                                size="14"
                                                color="#333333"
                                                padding={'0'}
                                                margin={'0'}
                                            >
                                                {`${
                                                    betslip.hasMarkets.length -
                                                        1 ===
                                                    index
                                                        ? ''
                                                        : `${name}:`
                                                } `}
                                            </Text>
                                            <Wrapper
                                                boxSizing={'border-box'}
                                                height={'auto'}
                                                padding={'0'}
                                                position={'relative'}
                                            >
                                                <ViewOddsInput
                                                    name={'odds-' + name}
                                                    label={
                                                        betslip.system.multi[
                                                            index
                                                        ] + 'x'
                                                    }
                                                    withoutLabel={
                                                        betslip.betList.length -
                                                            1 ===
                                                        index
                                                    }
                                                    valueHandler={this.valueSystemHandler.bind(
                                                        this,
                                                        index
                                                    )}
                                                    disabled={
                                                        this.state
                                                            .freeBetEnabled
                                                    }
                                                    validate={'minOdds'}
                                                    minOdds={5}
                                                    autoComplete={'off'}
                                                    type="text"
                                                    pattern="[0-9]+([\.][0-9]{1,2})?"
                                                    placeholder={`0.00`}
                                                    val={
                                                        this.state.oddsValues[
                                                            'odds-' + name
                                                        ]
                                                            ? this.state
                                                                  .oddsValues[
                                                                  'odds-' + name
                                                              ]
                                                            : ''
                                                    }
                                                />
                                            </Wrapper>
                                        </Wrapper>
                                    ))
                                    .reverse()}
                            </MobileFormWrapper>
                        </Wrapper>

                        <Wrapper
                            boxSizing={'border-box'}
                            height={'auto'}
                            flex
                            padding={'15px 0 0'}
                            justify={'space-between'}
                        >
                            <Text
                                align="left"
                                condensed
                                size="14"
                                color="#333333"
                                padding={'0'}
                                margin={'0'}
                            >
                                Mulig gevinst:
                            </Text>
                            <Text
                                align="right"
                                condensed
                                size="14"
                                color="#333333"
                                padding={'0'}
                                margin={'0'}
                            >
                                {getPossibleWinAmount(
                                    true,
                                    this.state.freeBetEnabled,
                                    user?.freeBet,
                                    user?.freeBetLive,
                                    betslip
                                )}{' '}
                                kr.
                            </Text>
                        </Wrapper>
                    </div>
                    {shouldDisplayNewsletter && isDerbyPermissionNull ? (
                        <NewsletterPermissionSwitch
                            userEmail={userEmail}
                            onEmailValidityChange={this.setEmailValidity}
                            isNewsletterSubscribed={
                                this.props.auth.user.newsletter === 1
                            }
                            hasUserPlacedBet={hasPlacedBet}
                        />
                    ) : null}
                    <div
                        className={`button-wrapper text-center ${
                            this.state.setFixedButton ? 'isFixedButton' : ''
                        }`}
                    >
                        <Wrapper
                            boxSizing={'border-box'}
                            height={'auto'}
                            flex
                            flexDirection={'center'}
                        >
                            {betSlipButtons}
                        </Wrapper>
                        {betslip.system.stake.some(
                            (bet) => bet > 0 && bet < 5
                        ) &&
                            !this.state.freeBetEnabled && (
                                <Wrapper
                                    boxSizing={'border-box'}
                                    height={'auto'}
                                    width={'100%'}
                                    flex
                                    flexAlign={'center'}
                                    flexDirection={'row'}
                                    justify={'center'}
                                    padding={'12px 0 0'}
                                    align={'center'}
                                >
                                    <img src={InfoIconRed} alt={'infoIcon'} />
                                    <Text
                                        width={'auto'}
                                        size={'12'}
                                        lh={'16'}
                                        color={'#DB1C1B'}
                                        margin={'0 0 0 5px'}
                                        padding={'0'}
                                        align={'center'}
                                        display={'inline-block'}
                                        flex={'0 auto'}
                                    >
                                        {errorMessageSystem}
                                    </Text>
                                </Wrapper>
                            )}
                    </div>
                </section>
            ) : (
                <section className={'section-wrapper'}>
                    <div className="multiple-coupon p20 pt15">
                        <Wrapper
                            boxSizing={'border-box'}
                            height={'auto'}
                            padding={'0 0 5px'}
                            flex
                            justify={'space-between'}
                        >
                            <Text
                                padding={'0'}
                                margin={'0'}
                                size={'14'}
                                lh={'14'}
                            >
                                {(betslip.customBetEventId !== null ||
                                    betslip.placedCustomBetMarkets.length >
                                        0) &&
                                betslip.betList.length > 1
                                    ? 'Kombination:'
                                    : 'Single:'}
                            </Text>
                            <Text
                                align={'right'}
                                padding={'0'}
                                margin={'0'}
                                size={'14'}
                                lh={'14'}
                            >
                                {this.props.betslip.totalOdds.toFixed(2)}
                            </Text>
                        </Wrapper>
                        <Wrapper
                            boxSizing={'border-box'}
                            height={'auto'}
                            flex
                            justify={'flex-end'}
                            padding={'0 0 15px'}
                        >
                            <MobileFormWrapper inputBlurOnSubmit={true}>
                                <ViewOddsInput
                                    withoutLabel
                                    label=""
                                    name="odds-0"
                                    placeholder={`0.00`}
                                    disabled={this.state.freeBetEnabled}
                                    autoComplete={'off'}
                                    type="text"
                                    pattern="[0-9]+([\.][0-9]{1,2})?"
                                    valueHandler={this.valueHandler.bind(this)}
                                    val={
                                        betslip.customBetEventId !== null ||
                                        betslip.placedCustomBetMarkets.length >
                                            0
                                            ? this.state.customBetStake > 0
                                                ? this.state.customBetStake
                                                : ''
                                            : this.state.oddsValues['odds-0'] >
                                              0
                                                ? this.state.oddsValues[
                                                      'odds-0'
                                                  ]
                                                : ''
                                    }
                                    validate="minOdds"
                                    minOdds={10}
                                    checkHandler={this.inputCheckHandler.bind(
                                        this
                                    )}
                                />
                            </MobileFormWrapper>
                        </Wrapper>

                        <Wrapper
                            boxSizing={'border-box'}
                            height={'auto'}
                            padding={'0'}
                            flex
                            justify={'space-between'}
                        >
                            <Text
                                align={'left'}
                                padding={'0'}
                                margin={'0'}
                                size={'14'}
                                lh={'14'}
                            >
                                Mulig gevinst:
                            </Text>
                            <Text
                                align={'right'}
                                padding={'0'}
                                margin={'0'}
                                size={'14'}
                                lh={'14'}
                            >
                                {getPossibleWinAmount(
                                    false,
                                    this.state.freeBetEnabled,
                                    user?.freeBet,
                                    user?.freeBetLive,
                                    betslip
                                )}{' '}
                                kr.
                            </Text>
                        </Wrapper>
                    </div>
                    {shouldDisplayNewsletter && isDerbyPermissionNull ? (
                        <NewsletterPermissionSwitch
                            userEmail={userEmail}
                            onEmailValidityChange={this.setEmailValidity}
                            isNewsletterSubscribed={
                                this.props.auth.user.newsletter === 1
                            }
                            hasUserPlacedBet={hasPlacedBet}
                        />
                    ) : null}
                    <div className="button-wrapper text-center">
                        {betSlipButtons}
                        {showSingleCustomBetErrorMessage(
                            betslip,
                            this.state.freeBetEnabled
                        ) && (
                            <Wrapper
                                boxSizing={'border-box'}
                                height={'auto'}
                                width={'100%'}
                                flex
                                flexAlign={'center'}
                                flexDirection={'row'}
                                justify={'center'}
                                padding={'12px 0 0'}
                                align={'center'}
                            >
                                <img src={InfoIconRed} alt={'infoIcon'} />
                                <Text
                                    width={'auto'}
                                    size={'12'}
                                    lh={'16'}
                                    color={'#DB1C1B'}
                                    margin={'0 0 0 5px'}
                                    padding={'0'}
                                    align={'center'}
                                    display={'inline-block'}
                                    flex={'0 auto'}
                                >
                                    {errorMessageSingle}
                                </Text>
                            </Wrapper>
                        )}
                    </div>
                </section>
            );

        const items = betslip.betList.map((item, index) => (
            <ViewBetslipItem
                isLiveBetDisabled={item.live && !this.isLiveBetActive(item)}
                key={index + 'Betslip item'}
                item={item}
                changed={betslip.changed}
                onRemoveHandler={this.onRemoveSystemHandler.bind(this)}
                itemError={betslip.itemError}
                isCustomBet={betslip.isCustomBet}
                customBetEventName={betslip.customBetEventName}
            />
        ));

        const errorMsg = betslip.error ? (
            <div className="error message text-center p10">
                <i className="fa fa-exclamation-triangle" aria-hidden="true" />
                {betslip.error}
            </div>
        ) : null;

        return (
            <div className="betslip-page">
                <ViewPageWrapper
                    showBackBtn="true"
                    title={user ? 'Balance: ' + user.balance + ' DKK' : ''}
                    buttonType={ViewPageWrapper.types.CLEAR_BETSLIP}
                    onCloseHandler={this.onCloseHandler.bind(this)}
                    onRightBtnHandler={this.onRightBtnHandler.bind(this)}
                >
                    <section
                        id={'systemBox'}
                        className={`betslip-page-cont ${
                            this.state.setFixedButton ? 'isFixedButton' : ''
                        } `}
                        ref={this.systemRef}
                    >
                        <div className={'content'}>
                            {errorMsg}
                            {items}
                            {!isTerminal() && this.FreeBetRow(betslip)}
                            {betListView}
                        </div>
                    </section>
                    {betslip.pending ? (
                        <ViewOverlayLoader removeLoader />
                    ) : null}

                    <AcceptBetslipChanges
                        onChange={this.onAcceptBetslipChanged}
                        accepted={this.state.isAcceptedBetslipChanges}
                    />
                </ViewPageWrapper>
                {this.state.rulesContent ? (
                    <UIModal
                        headerClass="noRound"
                        title="REGLER OG VILKÅR"
                        onCloseModal={this.onCloseModal.bind(this)}
                    >
                        <div className="p20">
                            <div
                                className="rules-and-terms-content"
                                dangerouslySetInnerHTML={{
                                    __html: this.state.rulesContent,
                                }}
                            />
                        </div>
                    </UIModal>
                ) : null}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        auth: state.auth,
        betslip: state.betslip,
        liveEvents: state.liveEvents,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        betslipActions: bindActionCreators(BetslipActions, dispatch),
        uiActions: bindActionCreators(UiActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BetslipPage);
